import { render } from "./CardVideoOrImg.vue?vue&type=template&id=668f6d9b"
import script from "./CardVideoOrImg.vue?vue&type=script&lang=js"
export * from "./CardVideoOrImg.vue?vue&type=script&lang=js"

import "./CardVideoOrImg.vue?vue&type=style&index=0&id=668f6d9b&labg=css&lang=css"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__